import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Buy from './views/buy.vue'
import YinSi from './views/yinsi.vue'
import IosCancel from './views/ioscancel.vue'
import Cancel from './views/cancel.vue'

import IosBuy from './views/iosbuy.vue'
import IosMember from './views/iosmember.vue'
import IosPrivacy from './views/iosyinsi.vue'

import XCIosMember from './views/心潮/iosmember.vue'
import XCIosBuy from './views/心潮/iosbuy.vue'
import XCwarn from './views/心潮/条款.vue' // 条款
import XCaliPay from './views/心潮/bindAliPay'
import bindWeChat from './views/心潮/bindWeChat'
import bindBank from './views/心潮/bindBank'
import htPrivicy from './views/心潮/隐私政策'

import dn8inn from './views/小程序/服务协议'
import gkqb8z from './views/小程序/隐私政策'
import fa0bc2 from './views/新的协议/小睡眠服务协议-安卓'
import cc492b from './views/新的协议/小睡眠App《隐私政策》安卓'
import androidBuy from './views/小睡眠/安卓/android-buy'
import ff7acd1 from './views/小睡眠/假期后作息调整'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/agreement', //小睡眠APP会员服务协议
      name: 'home',
      component: Home
    },
    {
      path: '/invite_friends_rule', //小睡眠APP会员服务协议
      name: 'inviteFriends',
      component: ()=>import('./views/other/invite_friends.vue')
    },
    {
      path: '/personal-infomation-list/:type?',
      name: 'personal-infomation-list',
      component: ()=>import('./views/other/personal-infomation-list.vue')
    },
    {
      path: '/privacy-summary',
      name: 'privacy-summary',
      component: ()=>import('./views/other/privacy-summary.vue')
    },
    {
      path: '/infomation-share-list',
      name: 'infomation-share-list',
      component: ()=>import('./views/other/infomation-share-list.vue')
    },
    {
      path: '/permission-desc',
      name: 'permission-desc',
      component: ()=>import('./views/other/permission-desc.vue')
    },
    {
      path: '/xc-personal-infomation-list/:type?',
      name: 'xc-personal-infomation-list',
      component: ()=>import('./views/other/xc-personal-infomation-list.vue')
    },
    {
      path: '/xc-privacy-summary',
      name: 'xc-privacy-summary',
      component: ()=>import('./views/other/xc-privacy-summary.vue')
    },
    {
      path: '/xc-infomation-share-list',
      name: 'xc-infomation-share-list',
      component: ()=>import('./views/other/xc-infomation-share-list.vue')
    },
    {
      path: '/xc-permission-desc',
      name: 'xc-permission-desc',
      component: ()=>import('./views/other/xc-permission-desc.vue')
    },
    {
      path: '/cbti',
      name: 'cbti',
      component: ()=>import('./views/other/cbti.vue')
    },
    {
      path: '/community-convention',
      name: 'community-convention',
      component: ()=>import('./views/other/community-convention.vue')
    },
    {
      path: '/buy',
      name: 'buy',
      component: Buy
    },
    {
      path: '/privacy', // 小睡眠APP隐私政策 by sgy
      name: 'yinsi',
      component: YinSi
    },
    {
      path: '/harmony', // 小睡眠APP隐私政策 by sgy
      name: 'harmony',
      component: ()=>import('./views/harmony/index.vue')
    },
    {
      path: '/harmony-agreement', //小睡眠APP鸿蒙会员服务协议
      name: 'harmony-agreement',
      component: ()=>import('./views/harmony/agreement.vue')
    },
    {
      path: '/ioscancel',
      name: 'ioscancel',
      component: IosCancel
    },
    {
      path: '/cancel',
      name: 'cancel',
      component: Cancel
    },
    {
      path: '/iosbuy',
      name: 'iosbuy2',
      component: IosBuy
    },
    {
      path: '/iosmember',
      name: 'iosmembe3r',
      component: IosMember
    },
    {
      path: '/iosprivacy',
      name: 'iosyinsi',
      component: IosPrivacy
    },

    // 心潮
    {
      path: '/xciosmember',
      name: 'iosmember',
      component: XCIosMember
    },
    {
      path: '/xciosbuy',
      name: 'iosbuy',
      component: XCIosBuy
    },
    {
      path: '/xcwarn', // 心潮APP服务协议 by sgy
      name: 'iosbuy',
      component: XCwarn
    },
    {
      path: '/xcalipay',
      name: 'xcalipay',
      component: XCaliPay
    },
    {
      path: '/xcbindwc',
      name: 'xcbindwc',
      component: bindWeChat
    },
    {
      path: '/xcbindbank',
      name: 'xcbank',
      component: bindBank
    },
    {
      path: '/dn8inn',
      name: 'dn8inn',
      component: dn8inn
    },
    {
      path: '/gkqb8z',
      name: 'gkqb8z',
      component: gkqb8z
    },
    {
      path: '/fa0bc2',
      name: 'fa0bc2',
      component: fa0bc2
    },
    {
      path: '/cc492b',
      name: 'cc492b',
      component: cc492b
    },
    {
      path: '/bf8290',//小睡眠APP自动续费协议
      name: 'androidBuy',
      component: androidBuy
    },
    {
      path: '/ff7acd1',
      name: 'ff7acd1',
      component: ff7acd1
    },
    {
      path: '/fa7abd0', // 心潮APP隐私政策 by sgy
      name: 'htPrivicy',
      component: htPrivicy
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})
